export enum HEADER {
  'UPDATE_HEADER' = '[HEADER] UPDATE_HEADER_TITLE'
}